import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20assortment%20of%20candies%20scattered%20on%20a%20bright%20white%20surface%20with%20soft%20pastel%20background%2C%20lollipops%2C%20gummy%20bears%2C%20colorful%20wrapped%20sweets%2C%20professional%20product%20photography%2C%20bright%20and%20cheerful%20composition%2C%20shallow%20depth%20of%20field%2C%20clean%20bright%20aesthetic&width=1600&height=900&seq=candy-hero-main&orientation=landscape"
        alt="愽彩糖果 - 缤纷糖果在线选购平台"
        title="愽彩糖果 - 缤纷糖果在线选购平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 drop-shadow-lg">
          缤纷糖果 甜蜜每一刻
        </h1>
        <p className="text-base md:text-lg text-white/90 max-w-2xl mb-8 drop-shadow">
          汇聚海量缤纷糖果，水果糖、巧克力、软糖、棒棒糖、精美礼盒一站购齐，下单即享优惠配送
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/category/fruit-candy"
            className="px-8 py-3 rounded-full text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
          >
            立即选购
          </Link>
          <Link
            to="/category/gift-box"
            className="px-8 py-3 rounded-full text-sm font-semibold bg-white/20 text-white border border-white/40 hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            糖果礼盒
          </Link>
        </div>
      </div>
    </section>
  );
}